import { Link, useSearchParams } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";
import NewsBrowser from "@/components/feature/NewsBrowser";
import NewsCard from "@/components/feature/NewsCard";
import { getLatestNews, searchNews } from "@/utils/news";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const keyword = params.get("q") ?? "";
  const trimmed = keyword.trim();
  const results = trimmed ? searchNews(trimmed) : [];
  const recommended = getLatestNews(3);

  useDocumentTitle(
    trimmed ? `“${trimmed}”的搜索结果 - 911爆料` : "搜索爆料 - 911爆料",
    "使用 911爆料 搜索功能，快速查找爆料新闻、社会热点与深度报道。"
  );

  const handleSearch = (next: string) => {
    if (next) {
      setParams({ q: next });
    } else {
      setParams({});
    }
  };

  return (
    <div className="mx-auto w-full max-w-shell animate-fade-up px-4 py-8 md:px-6 md:py-12">
      <div className="mx-auto max-w-2xl text-center">
        <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          搜索爆料
        </h1>
        <p className="mt-3 text-sm text-foreground-600">
          输入关键词，搜索标题、摘要、正文或来源，快速定位你关心的爆料。
        </p>
        <div className="mt-6">
          <SearchBox
            key={trimmed}
            variant="page"
            defaultValue={trimmed}
            onSearch={handleSearch}
            autoFocus
          />
        </div>
      </div>

      {!trimmed && (
        <div className="mt-12">
          <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-14 text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-2xl text-foreground-500">
              <i className="ri-search-eye-line" />
            </span>
            <p className="mt-4 text-sm text-foreground-600">
              请输入关键词开始搜索，或浏览下方的推荐内容。
            </p>
          </div>
        </div>
      )}

      {trimmed && (
        <div className="mt-10">
          <div className="mb-6 flex flex-wrap items-center gap-2 border-b border-background-200 pb-4 text-sm text-foreground-600">
            <span className="text-foreground-500">当前搜索词：</span>
            <span className="rounded-md bg-primary-100 px-2.5 py-1 font-medium text-primary-800">
              {trimmed}
            </span>
            <span className="ml-auto">
              找到 <strong className="text-accent-400">{results.length}</strong> 条结果
            </span>
          </div>

          {results.length > 0 ? (
            <NewsBrowser items={results} pageSize={5} />
          ) : (
            <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-14 text-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-2xl text-foreground-500">
                <i className="ri-emotion-unhappy-line" />
              </span>
              <p className="mt-4 text-sm text-foreground-600">
                未找到相关内容，您可尝试其他关键词或浏览推荐内容。
              </p>
              <Link
                to="/"
                className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
              >
                返回首页
              </Link>
            </div>
          )}
        </div>
      )}

      <section className="mt-12 border-t border-background-200 pt-8">
        <h2 className="font-heading text-lg font-bold text-foreground-950">
          推荐阅读
        </h2>
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {recommended.map((item) => (
            <NewsCard key={item.id} item={item} layout="vertical" />
          ))}
        </div>
      </section>
    </div>
  );
}